import { DateValue } from '@internationalized/date';
import {
  MoneyInput,
  PaymentMethod,
  PayBillItemInput,
  PayBillInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';
import { anyDateToISOString } from '~/shared/utils/dateTime';

export type PayBillItem = {
  billId: string;
  appliedAmount: MoneyInput;
};

export type PayBillParams = {
  accountId?: string | null;
  bills: PayBillItem[];
  paymentMethod: PaymentMethod;
  financialAccountId: string;
  transactionDate: DateValue;
  checkFacilityId?: string | null;
  checkNumber?: string | null;
  checkMemo?: string | null;
  achNumber?: string | null;
  wireNumber?: string | null;
};

export const payBillAtom = createMutationAtomFactory(
  'finance.payBill',
  (params: PayBillParams) => {
    const bills: PayBillItemInput[] = params.bills.map((b) => ({
      billId: b.billId,
      appliedAmount: b.appliedAmount,
    }));

    const input: PayBillInput = {
      bills,
      financialAccountId: params.financialAccountId,
      paymentMethod: params.paymentMethod,
      transactionDate: anyDateToISOString(params.transactionDate) ?? '',
    };

    if (params.accountId) {
      input.accountId = params.accountId;
    }
    if (params.checkFacilityId) {
      input.checkFacilityId = params.checkFacilityId;
    }
    if (params.checkNumber) {
      input.checkNumber = params.checkNumber;
    }
    if (params.checkMemo) {
      input.checkMemo = params.checkMemo;
    }
    if (params.achNumber) {
      input.achNumber = params.achNumber;
    }
    if (params.wireNumber) {
      input.wireNumber = params.wireNumber;
    }

    return {
      financePayBill: {
        __args: {
          input,
        },
        payment: {
          id: true,
          documentNumber: true,
          status: true,
          amount: {
            amount: true,
            currencyCode: true,
          },
          paymentMethod: true,
          transactionDate: true,
          timestamps: {
            createdAt: true,
            updatedAt: true,
          },
        },
        belowWarningThreshold: true,
        totalDiscount: {
          amount: true,
          currencyCode: true,
        },
      },
    };
  },
);
